<div class="add-bookmark-wrapper ">
  <div class="container has-blur-white-bg">
    <h2 class="isbold">New Bookmark</h2> 
    <form #form = 'ngForm' (ngSubmit)="onFormsubmit(form)">
      <div class="form-field">
        <div class="label">
          <label for="title">Name</label>
        </div>
        <input  ngModel  #titleField='ngModel' name="title" class="text-box" type="text" minlength="3" placeholder="Enter Bookmark name ...." >
      </div>
      <div class="form-field">
        <div class="label">
          <label for="url">URL</label>
        </div>
        <input  ngModel required  name="url" class="text-box" type="text" minlength="3" placeholder="Enter Bookmark url ...." >
      </div>
      <div class="buttons">
        <a class="btn-secondary btn" routerLink="../">Cancel</a>
        <button  class="btn-prim btn">Create Bookmark</button>
      </div>
    </form>
  </div>
</div>